<template>
  <div style="text-align: center; padding: 40px;">
    <p>正在处理...</p>
  </div>
</template>
<script>
import config from "../../../config/config";

export default {
  mounted() {
    // 1. 获取当前完整 URL
    const currentUrl = window.location.href;
    console.log('重定向后的完整路径:', currentUrl);
    let queryParams = window.location.search;
    if (!queryParams && window.location.hash.includes('?')) {
      // 从 hash 中提取查询参数
      const hashParts = window.location.hash.split('?');
      if (hashParts.length > 1) {
        queryParams = '?' + hashParts[1];
      }
    }
    // 2. 解析 URL 参数（如 code, state）
    const urlParams = new URLSearchParams(queryParams);
    const code = urlParams.get('code');
    const state = urlParams.get('state');
    // console.log('code,state', window.opener, window.opener.closed)
    // 4. 发送消息给打开这个窗口的主页面
    // if (window.opener && !window.opener.closed) {
    // ✅ 关键：发送消息
    window.opener.postMessage(
        {
          type: 'WECHAT_BIND',
          data: {'code': code, 'state': state}
        },
        config.BASE_URL
    );
    console.log('已发送消息给父窗口');
  }
  // 5. 延迟关闭弹窗
  // setTimeout(() => {
  //   window.close();
  //   console.log('关闭当前页面')
  // }, 1500);
  // },
}
</script>
<style scoped lang="scss">

</style>
